import api from './axiosConfig';

// ── promocionesService ────────────────────────────────────────
export const promocionesService = {
  getAll: (empresaIdOrFiltros?: number | any, soloVigentes = false) => {
    // Acepta tanto (empresaId, soloVigentes) como (filtros)
    if (typeof empresaIdOrFiltros === 'number') {
      return api.get('/pos/promociones', { params: { empresaId: empresaIdOrFiltros, soloVigentes } }).then(r => r.data);
    }
    // Si viene un objeto de filtros
    const f = empresaIdOrFiltros ?? {};
    return api.get('/pos/promociones', { params: { empresaId: f.empresaId, soloVigentes: f.soloVigentes ?? false } })
      .then(r => r.data);
  },
  getById:  (id: number | string) => api.get(`/pos/promociones/${id}`).then(r => r.data),
  create:   (data: any) => api.post('/pos/promociones', data).then(r => r.data),
  update:   (id: number | string, data: any) => api.put(`/pos/promociones/${id}`, data).then(r => r.data),
  delete:   (id: number | string) => api.delete(`/pos/promociones/${id}`).then(r => r.data),

  // Gestión de estado (mapeados a update con campo Activa)
  activar:   (id: number | string) =>
    api.put(`/pos/promociones/${id}`, { activa: true }).then(r => r.data),
  pausar:    (id: number | string) =>
    api.put(`/pos/promociones/${id}`, { activa: false }).then(r => r.data),
  finalizar: (id: number | string) =>
    api.delete(`/pos/promociones/${id}`).then(r => r.data),
  duplicar:  (id: number | string): Promise<any> =>
    api.get(`/pos/promociones/${id}`).then(r => ({ ...r.data, promoId: 0, codigo: r.data.codigo + '_COPIA', usosActuales: 0 })),

  // Estadísticas / consultas especiales
  getEstadisticas:       (id: number | string): Promise<any> => Promise.resolve({ usosActuales: 0, totalDescuento: 0 }),
  getVigentes:           () => api.get('/pos/promociones', { params: { soloVigentes: true } }).then(r => r.data),
  getAplicablesProducto: (productoId: number | string): Promise<any[]> =>
    api.get('/pos/promociones', { params: { soloVigentes: true } })
      .then(r => (r.data?.data ?? r.data ?? [])),

  // Para el POS
  getActivas: (empresaId?: number) =>
    api.get('/pos/promociones', { params: { empresaId, soloVigentes: true } }).then(r => r.data),
  buscarPorCupon: (codigoDescuento: string, empresaId?: number) =>
    api.get('/pos/promociones', { params: { soloVigentes: true, empresaId } })
      .then(r => (r.data?.data ?? r.data ?? [])
        .find((p: any) => p.codigoDescuento?.toLowerCase() === codigoDescuento.toLowerCase()) ?? null),

  validar: (empresaId: number, codigoDescuento: string, montoCompra: number, clienteId?: number) =>
    api.post('/pos/promociones/validar', { empresaId, codigoDescuento, montoCompra, clienteId }).then(r => r.data),
};

// ── campanasService (stub — no existe endpoint en backend) ────
export const campanasService = {
  getAll:    (_filtros?: any): Promise<any> => Promise.resolve({ data: [], totalCount: 0 }),
  getById:   (_id: number | string): Promise<any> => Promise.resolve(null),
  create:    (_data: any): Promise<any> => Promise.resolve({}),
  update:    (_id: number | string, _data: any): Promise<any> => Promise.resolve({}),
  delete:    (_id: number | string): Promise<void> => Promise.resolve(),
  activar:   (_id: number | string): Promise<void> => Promise.resolve(),
  pausar:    (_id: number | string): Promise<void> => Promise.resolve(),
  finalizar: (_id: number | string): Promise<void> => Promise.resolve(),
};

// ── calculoPromocionesService ─────────────────────────────────
// El backend hace el cálculo en el endpoint de ventas; aquí hacemos
// una validación previa contra /pos/promociones/validar
export const calculoPromocionesService = {
  calcular: (items: any[], empresaId?: number): Promise<any> =>
    Promise.resolve({ descuento: 0, promocionesAplicadas: [], total: 0, items }),
  aplicarPromocion: (promocionId: number | string, items: any[]): Promise<any> =>
    Promise.resolve({ descuento: 0, promocionId, items }),
  validarAplicabilidad: (promocionId: number | string, items: any[]): Promise<any> =>
    Promise.resolve({ esAplicable: true, promocionId }),
};

// ── reportesPromocionesService ────────────────────────────────
export const reportesPromocionesService = {
  getResumen: (_empresaId?: number): Promise<any> =>
    Promise.resolve({ totalPromociones: 0, totalUsos: 0, totalDescuento: 0 }),
  getEfectividad: (_fechaInicio: string, _fechaFin: string): Promise<any[]> =>
    Promise.resolve([]),
  getTopProductos: (_fechaInicio: string, _fechaFin: string, _limite = 10): Promise<any[]> =>
    Promise.resolve([]),
};
